import styled from 'styled-components';
import { getSizeBy } from '../../../src/styled/utils';
export const List = styled.ul `
  margin: 0;
  padding: 0;
  list-style: none;
`;
export const ListItem = styled.li `
  margin: 0 0 ${getSizeBy(3)};
  padding: 0;
  text-indent: 0;
  list-style-type: 0;

  &:last-child {
    margin: 0;
  }
`;
